// @ts-nocheck
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {BaseButton, BaseModal} from "@/components";
import {dropStorage, setStorage} from "@/store/util.store";
import {ErrorBoundaryHome} from "../../../components/ErrorBoundaryHandler/ErrorBoundaryHome";
import {useAuthStore} from "../../../store/useAuth.store";
import {useGameMetadataStore} from "../../../store/useGameMetadataStore";
import {useMiniGames} from "../../../store/useMiniGames";
import {RecentGames} from "../../private/Games/components/List/components";
import {TopGames} from "../../private/Games/components/List/components/top-games";
import {TopPayingGames} from "../../private/Games/components/List/components/top-paying-games";
import AllGamesList from "./components/AllGamesList";
import AppBanners from "./components/AppBanners";
import BoardGamesDisplay from "./components/BoardGamesDisplay";
import CasinoDisplay from "./components/CasinoDisplay";
import EGamesDisplay from "./components/EGamesDisplay";
import HipismoSection from "./components/HipismoSection";
import LotteryGamesCarousel from "./components/LotteryGamesCarousel";
import ModalSessionInfo from "./components/ModalSessionInfo";
import PaymentProfileCard from "./components/PaymentProfileCard";
import {PromoBanners} from "./components/PromoBanners";
import SlotsDisplay from "./components/SlotsDisplay";
import SportsDisplay from "./components/SportsDisplay";
import VirtualSportsDisplay from "./components/VirtualSportsDisplay";

const homeSectionsCls = "home-shell home-stack py-[clamp(32px,4vw,64px)]";

const HomePage = () => {
  const authStatus = useAuthStore(state => state.authStatus);
  const getMiniGames = useMiniGames(state => state.getMiniGames);
  const allGames = useMiniGames(state => state.list);

  // Initialize game metadata for home components
  const initializeGameMetadata = useGameMetadataStore(state => state.initializeGames);
  const gamesMetadataInitialized = useGameMetadataStore(state => state.initialized);
  const gamesMetadataLoading = useGameMetadataStore(state => state.loading);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (allGames.length === 0) {
      getMiniGames("all", null); // Load all games for the main games list
    }
  }, [allGames.length, getMiniGames]);

  useEffect(() => {
    if (!gamesMetadataInitialized && !gamesMetadataLoading) {
      initializeGameMetadata();
    }
  }, [gamesMetadataInitialized, gamesMetadataLoading, initializeGameMetadata]);

  useEffect(() => {
    if (authStatus === "unauthenticated") {
      setStorage("hasModalBeenShown", false);
    }

    // Clear mobile login flag if user accesses regular homepage
    // This prevents web users from being redirected to mobile login on logout
    if (window.location.pathname === "/") {
      dropStorage("isMobileLoginUser");
    }
  }, [authStatus]);

  const handleOk = () => {
    setIsModalOpen(false);
    navigate("/raffles");
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {authStatus === "authenticated" && (
        <>
          <ModalSessionInfo />
          <PaymentProfileCard />
          <AppBanners />
          <BaseModal
            title="Rifa Fin de Año"
            open={isModalOpen}
            onClose={handleCancel}
            size="lg"
          >
            <img
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
              onClick={handleOk}
              onKeyUp={e => {
                if (e.key === "Enter" || e.key === " ") {
                  handleOk();
                }
              }}
              alt="example"
              src="https://images.cdn.raspaygana.com.ve/raspaygana-rifa-diciembre2024-1.jpeg"
            />
            <BaseButton
              variant="primary"
              onClick={handleOk}
              style={{
                display: "block",
                width: "100%",
                marginTop: "1rem",
              }}
            >
              Compra YA!
            </BaseButton>
          </BaseModal>
        </>
      )}

      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ErrorBoundaryHome>
          <PromoBanners />
          <div className={homeSectionsCls}>
            <AllGamesList />

            {/* Sections */}

            <TopGames />

            <RecentGames />

            <TopPayingGames />

            <LotteryGamesCarousel />

            <HipismoSection />

            <SportsDisplay />

            <SlotsDisplay />

            <CasinoDisplay />

            <EGamesDisplay />

            <VirtualSportsDisplay />

            <BoardGamesDisplay />

            {/* <GamePromos /> */}
          </div>
        </ErrorBoundaryHome>
      </div>
    </>
  );
};

export default HomePage;
